import { gql } from '@apollo/client'

const CHALLENGE_QUERY = gql`
  query challenge($id: ID!) {
    challenge(id: $id) {
      id
      name
      description
      position
      type
      updatedAt
      updatedBy {
        id
        name
      }
      cuisineTypes {
        id
      }
      dishTypes {
        id
      }
      imageUrl
      maxPosition
    }
  }
`

export default CHALLENGE_QUERY
